'use strict';

const { captureMessage } = require('../../analytics/sentry');
var taskDone = require('./taskDone');

function checkBehaviour ($taskContainer, checked) {
  var lang = window.wooGlobal.language;
  var check = !checked;
  var category = $taskContainer.attr('data-category');
  var taskId = $taskContainer.attr('id').replace('project-task-', '');
  var projectTaskUrl = $('.marketing-checklist').attr('data-project-url');
  var checkUrl = '/' +
    lang + '/projects/' +
    projectTaskUrl + '/tasks/' +
    taskId + '/check';

  $taskContainer.addClass('proccessing');

  return $.ajax({
    type: 'POST',
    cache: false,
    data: {
      check: check ? 1 : 0
    },
    url: checkUrl,
    dataType: 'json',
    success: function (res) {
      if (res.checked == null) {
        res.checked = false;
      }

      $taskContainer.fadeOut(400, function () {
        taskDone($taskContainer, category, res.checked);
      });
    },
    error: function (jqXHR, textStatus, errorThrown) {
      captureMessage('Marketing checklist checking item error', {
        extra: {
          textStatus: textStatus,
          errorThrown: errorThrown,
          currentWebsite: window.currentWebsite
        }
      });

      return $taskContainer.removeClass('proccessing');
    }
  });
}

module.exports = checkBehaviour;
